export { default as path } from './path.constant';
export { default as regex } from './regex.constant';
export { default as sidebar } from './sidebar.constant';
export const  ADMIN_TYPE='KALP-STUDIO-SUPER-ADMIN'
